const currentHref = typeof window !== "undefined" ? window.location.href : "";
const isLocalPreviewHost = currentHref.indexOf("localhost") >= 0 || currentHref.indexOf("192.168") >= 0;

export default {
  title: "erp系统管理",
  siteCode: "supplychain",
  tokenKey: "sj_mall_admin_token",
  qiniuTokenUrl: "http://qiniutoken.panycode.com/token",
  // collectionH5SiteUrl: "http://localhost:8033",
  homeUrl: "/mall/home",
  collectionHomeUrl: "/mall/home",
  homeRouteName: "mallHome",
  isPrefixCollectionH5SiteUrl:true,
  hiddenMenuCodesMap:{ "collectionCenter":true },
  getCollectionH5SiteUrlByServiceList: true,
  collectionH5SiteCodeMap:{
    // "tmyt-jy":"//member.dqc56.cn",
    // "tmyt-df":"//df.omszt.com",
    // "tm-thor":"//member.lsjy56.com",
  },
  collectionH5SiteUrl: "http://xjhy.m-shop-test.omszt.com:7888",
  // collectionH5SiteUrl: "http://localhost:8033",
  qiniuPath: "http://cdn.iluckey.com",
  qiniuUploadUrl: "http://upload-z0.qiniup.com",
  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: true,
  getPreSiteUrl(){
    return !process.env.BASE_URL||process.env.BASE_URL=='/'?"":process.env.BASE_URL.replace(/\/$/g,'')
  }
 
};
